export const h1 = '42px';
export const h2 = '32px';
export const h3 = '26px';
export const h4 = '22px';
export const h5 = '18px';
export const text = '16px';
export const h6 = text;



// WEBPACK FOOTER //
// ./app/fontSizes.js